import { isSameDay, startOfMonth, startOfWeek, startOfYear } from 'date-fns';
import { Formatter } from '@/core/utils/Formatter';
import { type DateRange } from '@/types';
import { MAX_SAFE_DATE, TimeFilterPresets } from '../TimeFilterControl.const';

export const useTimePresetFromDateRange = () => {
  const today = new Date();

  return ({ from, to }: DateRange) => {
    const fromDate = Formatter.toUTC(from);
    const toDate = Formatter.toUTC(to);

    if (isSameDay(fromDate, today) && isSameDay(toDate, today)) {
      return TimeFilterPresets.CURRENT_DAY;
    }

    if (isSameDay(fromDate, startOfWeek(today, { weekStartsOn: 0 })) && isSameDay(toDate, today)) {
      return TimeFilterPresets.CURRENT_WEEK;
    }

    if (isSameDay(fromDate, startOfMonth(today)) && isSameDay(toDate, today)) {
      return TimeFilterPresets.CURRENT_MONTH;
    }

    if (isSameDay(fromDate, startOfYear(today)) && isSameDay(toDate, today)) {
      return TimeFilterPresets.CURRENT_YEAR;
    }

    if (isSameDay(fromDate, today) && isSameDay(toDate, MAX_SAFE_DATE)) {
      return TimeFilterPresets.FUTURE;
    }

    return TimeFilterPresets.CUSTOM_RANGE;
  };
};
